import router from '@/router'

const state = {
  menus: [],
  activeIndex: '0',
  top_bg: false
}

const getSelectedItem = (data, path) => {
  for (let i = 0; i < data.length; i++) {
    if (data[i].path === path) {
      if (data[i].isChildren) {
        return data[i].children
      } else {
        return data
      }
    } else if (path === '/' || path === '/index') {
      return data
    } else {
      if (data[i].children && data[i].children.length > 0) {
        for (let k = 0; k < data[i].children.length; k++) {
          if (data[i].children[k].path === path) {
            return data[i].children
          }
        }
      }
    }
  }
}

const mutations = {
  SET_MENUS: (state, data) => {
    const routes = router.options.routes
    let key = data.path

    // 新增条件判断，当路径为 /supplychaindddd 时，不执行更新操作
    if (key === '/newsCenter') {
      return;
    }

    const menus = getSelectedItem(routes, key)
    if (key === '/' || key === '/index') {
      key = '/'
    }

    menus.forEach((item, index) => {
      if (item.path === key) {
        state.activeIndex = String(index)
      }
    })

    state.menus = menus
  },
  SET_TOP_BG: (state, data) => {
    state.top_bg = data
  }
}


export default {
  namespaced: true,
  state,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/app.js